import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { Validator } from 'vee-validate'

export default {
  name: 'AWBVerificationDimWt',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      AWBnumber:'',
      addmodalShow: false,
      isLoadingSearch:false,
      isPhysicalWeightBeyondThreshold: [],
      isVolumetricWeightBeyondThreshold: [],
      totalDimRows: 0,
      inputs: {},
      remArr: [],
      CFTValue: 0,
      ppw : '',
      pvw : '',
      awbvst : '',
      vpw : '',
      vvw : '',
      awbvdby : '',
      pwd : '',
      vwd : '',
      awbvdat : '',
      awbvdt : '',
      totbx : 0,
      totRc : 0,
      hubid : '',
      isverificationenabled:true,
      isverificationenabledMsg:'',
      confmsg:'',
      isdisable:true,
      destinationhubId:'',
      currentTab: 'manual',
      tabs: [{
					key: 'manual',
					value: 'AWB - SKU Level Data'
				}
        // {
				// 	key: 'manual',
				// 	value: 'Manual'
				// },
				// {
				// 	key: 'dws',
				// 	value: 'DWS'
				// }
			],
      verificationMethod: '',
      mCount: 0,
      pCount: 0,
      inScanMethod: '',
      dwsModalShow: false,
      pvRatioFlag:false,
      pvRatioShow:false,
      pvMinRatio:0,
      pvMaxRatio:0,
      pvratiovalue :0,
      empSKUError:'',
      pvSKUError:'',
      pvSKUSerial:'',
      pvRatioCounter:0
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  filters: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;
    this.hubid            = userdetail[0].HubId[0];

    this.AWBnumber        = this.$route.query.AWBNo ? this.$route.query.AWBNo : '';
    this.destinationhubId = this.$route.query.destinationhubId ? this.$route.query.destinationhubId : '';
    this.$refs.AWBnumber.focus();

    this.checkVerificationPalletizationEnabled();
    this.getHubName(userdetail[0].HubId);
  },
  methods: {

    validateAWBInputs() {
      const isAWBEmpty = !this.AWBnumber.trim();
      const isVPWInvalid = isNaN(Number(this.vpw));
      const isVVWInvalid = isNaN(Number(this.vvw));
      const isPhysicalThresholdExceeded = this.isPhysicalWeightBeyondThreshold.some(Boolean);
      const isVolumetricThresholdExceeded = this.isVolumetricWeightBeyondThreshold.some(Boolean);
      const isVPWTooHigh = Number(this.vpw) >= Number(this.inputs_config.max_parentWt[0]);
      const isVVWTooHigh = Number(this.vvw) >= Number(this.inputs_config.max_parentWt[1]);
  
      if (
        isAWBEmpty ||
        isVPWInvalid ||
        isVVWInvalid ||
        isPhysicalThresholdExceeded ||
        isVolumetricThresholdExceeded ||
        isVPWTooHigh ||
        isVVWTooHigh
      ) {
        if (isVPWInvalid) {
          this.$alertify.error("Physical Weight values are invalid");
        } else if (isVVWInvalid) {
          this.$alertify.error("Volumetric Weight values are invalid");
        } else if (isPhysicalThresholdExceeded) {
          this.$alertify.error("One or more boxes exceed the Physical weight threshold");
        } else if (isVolumetricThresholdExceeded) {
          this.$alertify.error("One or more boxes exceed the Volumetric weight threshold");
        } else if (isVVWTooHigh) {
          this.$alertify.error(
            `Verified AWB Volumetric weight should be less than ${this.inputs_config.max_parentWt[1]}!`
          );
        } else if (isVPWTooHigh) {
          this.$alertify.error(
            `Verified AWB Physical weight should be less than ${this.inputs_config.max_parentWt[0]}!`
          );
        }
        return false;
      }
      return true;
    },
    secondFunction(){
      if(this.currentTab=='dws') this.getAWBMPSDWSList();
      else this.getAWBVerificationDimWt();
    },

    getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.awbvdat = result.data.ResponseData[0].HubName + " (" + result.data.ResponseData[0].HubID + ") "
          }
        }, error => {
          console.error(error)
        })
    },

    getAWBVerificationDimWt(){
      if(!this.AWBnumber.trim()) return false;
      this.isPhysicalWeightBeyondThreshold= [],
      this.isVolumetricWeightBeyondThreshold= [],
      this.isLoadingSearch  = true;
      this.inputs           = {};
      this.remArr           = [];
      this.verificationMethod = '';
      this.totRc            = 0;
      this.totbx            = 0;
      this.ppw              = 0;
      this.vpw              = 0;
      this.pwd              = 0;
      this.pvw              = 0;
      this.vvw              = 0;
      this.vwd              = 0;
      this.currentTab       = 'manual';
      this.pvRatioFlag      = false;
      this.pvRatioShow      = false;
      this.pvMinRatio       = 0;
      this.pvMaxRatio       = 0;
      this.pvRatioCounter   = 0;
      this.pvSKUError       = '';
      this.empSKUError      = '';

      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + "getParentDetailsforAWBVerification?ParentAWB="+this.AWBnumber + '&currentHubId=' + this.hubid,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {

          this.inputs   = result.data.parentAWBDetailsResponseData;
          this.inputs.TotalPickupVolumetricWeight = !this.inputs.TotalPickupVolumetricWeight ? 0 : this.inputs.TotalPickupVolumetricWeight;
          //  HUB:6668: Physical/Volumetric Wt validation on AWS Screen
          this.inputs_config  = result.data.config;
          this.pvMinRatio       = (result.data.pvRatio.pvminratio) ? result.data.pvRatio.pvminratio : 0;
          this.pvMaxRatio       = (result.data.pvRatio.pvmaxratio) ? result.data.pvRatio.pvmaxratio : 0;

          this.CFTValue = result.data.CFTValue;
          this.awbvdby  = this.inputs.MeasurementDoneBy ? this.inputs.MeasurementDoneBy : '';
          this.awbvdt   = this.inputs.MeasurementTime ? this.inputs.MeasurementTime : '';
          this.awbvdat  = this.inputs.MeasurementLocationName ? this.inputs.MeasurementLocationName : '';
          this.awbvst  = this.inputs.IsMeasurementFlag ? 'Completed' : 'Pending';
          this.inScanMethod = (this.awbvst=='Completed') ? 'Manual':'';

          this.totRc    = this.inputs.SKUDetails.length;
          this.totbx    = this.inputs.MPSCount;
          this.ppw      = (Math.floor(parseFloat(this.inputs.TotalPickupPhysicalWeight) * 1000) / 1000).toFixed(3);
          this.vpw      = (this.inputs.TotalVerifiedPhysicalWeight > 0) ? (Math.floor(parseFloat(this.inputs.TotalVerifiedPhysicalWeight) * 1000) / 1000).toFixed(3) : '';
          this.pwd      = (Math.floor(parseFloat(parseFloat(this.inputs.TotalVerifiedPhysicalWeight) - parseFloat(this.inputs.TotalPickupPhysicalWeight)) * 1000) / 1000).toFixed(3);
          this.pvw      = (Math.floor(parseFloat(this.inputs.TotalPickupVolumetricWeight) * 1000) / 1000).toFixed(3);
          this.vvw      = (this.inputs.TotalVerifiedVolumetricWeight > 0) ? (Math.floor(parseFloat(this.inputs.TotalVerifiedVolumetricWeight) * 1000) / 1000).toFixed(3) : '';
          this.vwd      = (Math.floor(parseFloat(parseFloat(this.inputs.TotalVerifiedVolumetricWeight) - parseFloat(this.inputs.TotalPickupVolumetricWeight)) * 1000) / 1000).toFixed(3);

          for (var i = 0; i < this.inputs.SKUDetails.length; i++) {
            this.inputs.SKUDetails[i].serial = i+1;
            this.inputs.SKUDetails[i].pvReset = false;

            //this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight) / parseFloat(this.inputs.SKUDetails[i].NoOfBoxes)) * 1000) / 1000).toFixed(3);
            this.inputs.SKUDetails[i].totPWeight = (Math.floor(parseFloat(this.inputs.SKUDetails[i].BoxTotalPhysicalWeight) * 1000) / 1000).toFixed(3);
            //this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight = (Math.floor(parseFloat((parseFloat(this.inputs.SKUDetails[i].BoxDimensions) / parseFloat(this.CFTValue)) * parseFloat(this.inputs.SKUDetails[i].NoOfBoxes)) * 1000) / 1000).toFixed(3);
            this.inputs.SKUDetails[i].totVWeight = (Math.floor(parseFloat(this.inputs.SKUDetails[i].BoxTotalVolumetricWeight) * 1000) / 1000).toFixed(3);

            // Calculate SKU PV Ratio
            this.calcSKUPVRatio(this.inputs.SKUDetails[i]);
          }
          this.pvRatioFlag = result.data.pvRatioFlag ;
          this.calcPVRatio();
          this.isdisable = false;
          this.isLoadingSearch = false;
        }else{
          if(result.data.ResultCode == 103 && result.data.AWBVerificationMethod && result.data.AWBVerificationMethod.toLowerCase() == 'dws')
          {
            this.verificationMethod  = result.data.AWBVerificationMethod ? result.data.AWBVerificationMethod.toLowerCase() : '';
            this.getAWBMPSDWSList();
          }
          else{
              this.$alert(result.data.ReturnMessage, "", "error");
              this.isLoadingSearch = false;
          }
        }
      }, error => {
        this.isLoadingSearch = false; console.error(error);
      })
    },

    getAWBMPSDWSList(){
      if(!this.AWBnumber.trim()) return false;

      this.isLoadingSearch  = true;
      this.inputs           = {};
      this.currentTab       = 'dws';
      this.mCount           = 0;
      this.pCount           = 0;
      this.totbx            = 0;
      this.ppw              = 0;
      this.vpw              = 0;
      this.pwd              = 0;
      this.pvw              = 0;
      this.vvw              = 0;
      this.vwd              = 0;
      this.pvRatioFlag      = false;
      this.pvRatioShow      = false;
      this.pvMinRatio       = 0;
      this.pvMaxRatio       = 0;

      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + "getParentDetailsforAWBVerification_DWS?ParentAWB="+this.AWBnumber + '&currentHubId=' + this.hubid,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
      .then(async result => {
        if (result.data.ResultCode == 100) {
          this.inputs   = result.data.parentAWBDetailsResponseData;
          this.inputs_config  = result.data.config;
          this.pvMinRatio       = (result.data.pvRatio.pvminratio) ? result.data.pvRatio.pvminratio : 0;
          this.pvMaxRatio       = (result.data.pvRatio.pvmaxratio) ? result.data.pvRatio.pvmaxratio : 0;

          this.CFTValue = result.data.CFTValue;
          this.awbvdby  = this.inputs.MeasurementDoneBy ? this.inputs.MeasurementDoneBy : '';
          this.awbvdt   = this.inputs.MeasurementTime ? this.inputs.MeasurementTime : '';
          this.awbvdat  = this.inputs.MeasurementLocationName ? this.inputs.MeasurementLocationName : '';
          this.awbvst   = this.inputs.IsMeasurementFlag ? 'Completed' : 'Pending';
          this.mCount   = this.inputs.MeasuredCount;
          this.pCount   = this.inputs.PendingCount;
          this.inScanMethod = (this.awbvst=='Completed') ? 'DWS':'';
          this.totbx    = this.inputs.MPSCount;
          this.ppw      = (Math.floor(parseFloat(this.inputs.TotalPickupPhysicalWeight) * 1000) / 1000).toFixed(3);
          this.vpw      = (this.inputs.TotalVerifiedPhysicalWeight > 0) ? (Math.floor(parseFloat(this.inputs.TotalVerifiedPhysicalWeight) * 1000) / 1000).toFixed(3) : '';
          this.pwd      = (Math.floor(parseFloat(parseFloat(this.inputs.TotalVerifiedPhysicalWeight) - parseFloat(this.inputs.TotalPickupPhysicalWeight)) * 1000) / 1000).toFixed(3);
          this.pvw      = (Math.floor(parseFloat(this.inputs.TotalPickupVolumetricWeight) * 1000) / 1000).toFixed(3);
          this.vvw      = (this.inputs.TotalVerifiedVolumetricWeight > 0) ? (Math.floor(parseFloat(this.inputs.TotalVerifiedVolumetricWeight) * 1000) / 1000).toFixed(3) : '';
          this.vwd      = (Math.floor(parseFloat(parseFloat(this.inputs.TotalVerifiedVolumetricWeight) - parseFloat(this.inputs.TotalPickupVolumetricWeight)) * 1000) / 1000).toFixed(3);

          this.pvRatioFlag = result.data.pvRatioFlag;

          await this.vvvpwtDwsCalc();

          this.isdisable = false;
          this.isLoadingSearch = false;

        }else{
          if(result.data.ResultCode == 103  && result.data.AWBVerificationMethod && result.data.AWBVerificationMethod.toLowerCase() == 'manual')
          {
            this.$alertify.error(result.data.ReturnMessage);
            this.getAWBVerificationDimWt();
          }
          else{
          this.$alert(result.data.ReturnMessage, "", "error");
          this.isLoadingSearch = false;
          }
        }
      }, error => {
        this.isLoadingSearch = false; console.error(error);
      })
    },

    onSubmit: async function () {
      try {

        const result = await this.$validator.validateAll();

        this.pvSKUError  = '';
        this.empSKUError = '';
        
        this.confmsg = 'Do you want to verify AWB number dimensions & weight.';

        if (!result) {
          console.log('errors exist'); return false;
        }

        let noOfBox = 0;
        if (this.currentTab === 'dws') {
          let manualCount = 0;
          this.inputs.MPSDetails.forEach(x => {
            if (x.MPSInScanFromDevice.toLowerCase() === "manual") {
              manualCount++;
            }
          });
          noOfBox = parseInt(this.inputs.MeasuredCount) + manualCount;
        } else {
          noOfBox = this.inputs.SKUDetails.reduce((sum, current) => {
            return parseInt(sum) + parseInt(current.NoOfBoxes);
          }, 0);

          // Get serials where L,B,H,PhyWeight is 0, null, or empty
          await this.checkEmptySKU();
          if (this.empSKUError) return;

          // Erase all values except ‘Number of boxes’
          await this.resetPVRatioSKU();
          if (this.pvSKUError) return;
        }

        if(noOfBox == this.inputs.MPSCount){
          if(this.ppw != this.vpw)
            this.confmsg = 'There is a difference between Verified physical weight and Picked physical weight. Click confirm to save the Verified physical weight.';
          else if(this.pvw != this.vvw)
            this.confmsg = 'There is a difference between Verified volumetric weight and Picked volumetric weight. Click confirm to save the Verified volumetric weight.';
          else if(noOfBox < this.inputs.MPSCount)
            this.confmsg = 'The number of Box Types picked is different from the Number of Box Types verified. Please check and confirm.';

          this.addmodalShow = true;
        }else{
          this.$alert("Number of boxes mismatch between header and line", "", "error");
        }
      } catch (error) {
        console.error(error);
      }
    },

    addBox () {
      if(!this.AWBnumber.trim()) return false;

      if(this.inputs.SKUDetails){
        this.inputs.SKUDetails.push({
          "HSN": null,
          "SKU": "Other",
          "BoxType": "Other",
          "SKUType": this.inputs.SKUDetails.length+1,
          "NoOfBoxes": "",
          "SKUAction": "Add",
          "NoOfInscan": null,
          "OtherBoxType": 1,
          "BoxDimensions": "",
          "PackageDetails": {
            "Weight": {
              "Unit": "Kg",
              "PhyWeight": "",
              "VolWeight": "",
              "BillableWeight": ""
            },
            "Dimensions": {
              "Unit": "cm",
              "Width": "",
              "Height": "",
              "Length": ""
            }
          },
          "ChildNoOfInscan": null,
          "UniqueReferenceNumber": null,
          "serial": this.inputs.SKUDetails.length+1,
          "pvRatioFlag": false,
          "pvratiovalue": 0,
          "wtinscan":"Manual"
        })
      }
    },

    removeBoxes (){
      if(this.remArr.length>0){
        let rArr = new Set(this.remArr);

        this.inputs.SKUDetails = this.inputs.SKUDetails.filter((val, i) => { return val.wtinscan.toLowerCase() == 'dws' || !rArr.has(i); }).map((item, index) => {
          item.serial = index + 1;
          return item;
        });

        //  HUB:6668: Physical/Volumetric Wt validation on AWS Screen
        // Remove the flag from index variable:  isPhysicalWeightBeyondThreshold
        this.isPhysicalWeightBeyondThreshold = this.isPhysicalWeightBeyondThreshold.filter((val, i) => !rArr.has(i));
        this.isVolumetricWeightBeyondThreshold = this.isVolumetricWeightBeyondThreshold.filter((val, i) => !rArr.has(i));
        this.vpw = (Math.floor(this.inputs.SKUDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.totPWeight)); }, 0) * 1000) / 1000).toFixed(3);
        this.pwd = (Math.floor(parseFloat(parseFloat(this.vpw) - parseFloat(this.ppw)) * 1000) / 1000).toFixed(3);
        this.vvw = (Math.floor(this.inputs.SKUDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.totVWeight)); }, 0) * 1000) / 1000).toFixed(3);
        this.vwd = (Math.floor(parseFloat(parseFloat(this.vvw) - parseFloat(this.pvw)) * 1000) / 1000).toFixed(3);

        this.remArr = [];

        this.calcPVRatio();
      }
    },

    closeStatusModal() {
      this.addmodalShow = false
      this.dwsModalShow = false
    },

    //function is used for calculate weight
    boxWeightCalc(i, type = 'box') {
      this.isdisable = true;

      const sku = this.inputs.SKUDetails[i];
      const dim = sku.PackageDetails.Dimensions;
      const wt = sku.PackageDetails.Weight;

      // Normalize values
      dim.Length = dim.Length > 0 ? dim.Length : '';
      dim.Width  = dim.Width > 0 ? dim.Width : '';
      dim.Height = dim.Height > 0 ? dim.Height : '';
      sku.NoOfBoxes = sku.NoOfBoxes > 0 ? sku.NoOfBoxes : '';
      wt.PhyWeight = wt.PhyWeight > 0 ? wt.PhyWeight : '';

      // Basic validation
      if ((dim.Length && dim.Length <= 0) || (dim.Width && dim.Width <= 0) || (dim.Height && dim.Height <= 0) || (sku.NoOfBoxes && sku.NoOfBoxes <= 0)) {
        this.$alertify.error("Input value should be greater than 0!");
        return false;
      }else if (!dim.Length || !dim.Width || !dim.Height || !sku.NoOfBoxes) {
        return false;
      }

      if (type === 'phy' && !wt.PhyWeight) {
        this.$alertify.error("Physical weight should be greater than 0!");
        return false;
      }

      // Calculate Volumetric Weight
      wt.VolWeight = (
        Math.floor(
          (((dim.Length * dim.Width * dim.Height) / 27000) * this.CFTValue) * 1000
        ) / 1000
      ).toFixed(3).toString();

      // Threshold checks
      if (Number(wt.VolWeight) >= this.inputs_config.max_mpsWt[1]) {
        this.$alertify.error(`Volumetric weight should be less than ${this.inputs_config.max_mpsWt[1]}!`);
        this.isVolumetricWeightBeyondThreshold[i] = true;
      } else {
        this.isVolumetricWeightBeyondThreshold[i] = false;
      }

      if (type === 'phy') {
        if (Number(wt.PhyWeight) >= this.inputs_config.max_mpsWt[0]) {
          this.$alertify.error(`Physical weight should be less than ${this.inputs_config.max_mpsWt[0]}!`);
          this.isPhysicalWeightBeyondThreshold[i] = true;
        } else {
          this.isPhysicalWeightBeyondThreshold[i] = false;
        }
      }

      // Duplicate check
      const currBox = sku.NoOfBoxes;
      const otherRows = this.inputs.SKUDetails.filter((_, idx) => idx !== i);

      const result = otherRows.find(obj =>
        Number(obj.PackageDetails.Dimensions.Length).toFixed(2) === Number(dim.Length).toFixed(2) &&
        Number(obj.PackageDetails.Dimensions.Width).toFixed(2) === Number(dim.Width).toFixed(2) &&
        Number(obj.PackageDetails.Dimensions.Height).toFixed(2) === Number(dim.Height).toFixed(2) &&
        Number(obj.PackageDetails.Weight.PhyWeight || 0).toFixed(3) === Number(wt.PhyWeight || 0).toFixed(3)
      );

      if (result) {
        if (!result.UniqueReferenceNumber) {
          this.$alert("One or more boxes with the same dimensions are already available, so the number of the new box will be added to the old box", "", "error");

          this.inputs.SKUDetails.splice(i, 1);

          const index = this.inputs.SKUDetails.findIndex(x => x.SKUType === result.SKUType);
          if (index >= 0) {
            this.inputs.SKUDetails[index].NoOfBoxes =
              parseInt(this.inputs.SKUDetails[index].NoOfBoxes) + parseInt(currBox);
            i = index;
          }

          this.inputs.SKUDetails = this.inputs.SKUDetails.map((item, index) => {
            item.serial = index + 1;
            return item;
          });

        } else {
          this.$alert("One or more boxes with the same dimensions are already available, and new boxes with the same dimensions will not be accepted", "", "error");
          return false;
        }
      }

      // Totals calculation
      if (sku.NoOfBoxes) {
        sku.totPWeight = (wt.PhyWeight * sku.NoOfBoxes).toFixed(3);
        sku.totVWeight = (wt.VolWeight * sku.NoOfBoxes).toFixed(3);

        wt.BillableWeight = Math.max(wt.PhyWeight || 0, wt.VolWeight).toString();

        this.vpw = this.inputs.SKUDetails
          .reduce((sum, cur) => sum + Number(cur.totPWeight || 0), 0)
          .toFixed(3);

        this.vvw = this.inputs.SKUDetails
          .reduce((sum, cur) => sum + Number(cur.totVWeight || 0), 0)
          .toFixed(3);

        this.pwd = (this.vpw - this.ppw).toFixed(3);
        this.vwd = (this.vvw - this.pvw).toFixed(3);
      }

      // AWB level validation
      if (Number(this.vvw) >= this.inputs_config.max_parentWt[1]) {
        this.$alertify.error(`Verified AWB Volumetric weight should be less than ${this.inputs_config.max_parentWt[1]}!`);
      }

      if (Number(this.vpw) >= this.inputs_config.max_parentWt[0]) {
        this.$alertify.error(`Verified AWB Physical weight should be less than ${this.inputs_config.max_parentWt[0]}!`);
      }

      // PV Ratio
      this.calcSKUPVRatio(this.inputs.SKUDetails[i]);
      this.calcPVRatio();

      this.isdisable = false;
    },

    takeAction() {
      this.addmodalShow = false;
      this.pvRatioShow  = false;
      
      if(this.currentTab == 'dws'){
        this.verifyMPSDWS();
      }else{
        this.verifyAWB();
      }
    },

    calcSKUPVRatio(item){
      item.pvRatioFlag = false;

      item.pvratiovalue  = parseFloat(item.totPWeight / item.totVWeight) || 0;

      if((item.pvratiovalue <= parseFloat(this.pvMinRatio)) || (item.pvratiovalue >= parseFloat(this.pvMaxRatio))){
        item.pvRatioFlag = true;
      }
      return item;
    },

    calcPVRatio(){
      this.pvRatioFlag = false;
      this.pvratiovalue =0;

      if((this.vpw > 0) && (this.vvw > 0)){
        this.pvratiovalue = parseFloat(this.vpw / this.vvw);
      }else{
        this.pvratiovalue = parseFloat(this.ppw / this.pvw);
      }

      if((this.pvratiovalue <= parseFloat(this.pvMinRatio)) || (this.pvratiovalue >= parseFloat(this.pvMaxRatio))){
        this.pvRatioFlag = true;
      }
    },

    openPVRatioModal(){
      this.addmodalShow = false;
      this.pvRatioShow  = true;
    },

    nullNestedObject(obj) {
      Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.nullNestedObject(obj[key])
        } else {
          if(key !== 'Unit') obj[key] = null
        }
      })
    },

    // Function to set everything to null except NoOfBoxes and return the updated array
    resetPVRatioSKU(){
      let emptySKU = [];

      this.inputs.SKUDetails.forEach(item => {
        if (item.pvRatioFlag && item.wtinscan.toLowerCase() != 'dws') {
          if(this.pvRatioCounter == 0){
            
              Object.keys(item).forEach(key => {
                if (['PackageDetails','UniqueReferenceNumber','BoxDimensions','BoxTotalPhysicalWeight','BoxTotalVolumetricWeight','totPWeight','totVWeight'].includes(key)) {
                  
                  if (typeof item[key] === 'object' && item[key] !== null) {
                    this.nullNestedObject(item[key])
                  } else {
                    item[key] = null
                  }
                }
              });

            item.pvRatioFlag    = false;
            item.pvReset        = (item.hasOwnProperty('pvReset')) ? true : false;
          }

          emptySKU.push(item.serial);
        }
      });

      this.pvRatioCounter = this.pvRatioCounter+1;
      this.pvSKUSerial    = (emptySKU.length) ? emptySKU.join() : '';

      if(this.pvSKUSerial && this.pvRatioCounter == 1 ){
        this.pvSKUError = `PV ratio for SKU (S.No. ${this.pvSKUSerial}) verification failed! Enter their L, B, H & Phy. Wt values`;
      }
      return this.pvSKUError;
    },
    
    // Function to check and return serial numbers where L,B,H,PhyWeight is 0, null, or empty
    checkEmptySKU(){
      let emptySKU = this.inputs.SKUDetails.filter(item => {
        const phy     = Number(item.PackageDetails.Weight.PhyWeight);
        const width   = Number(item.PackageDetails.Dimensions.Width);
        const height  = Number(item.PackageDetails.Dimensions.Height);
        const length  = Number(item.PackageDetails.Dimensions.Length);

        return ( !phy || phy <= 0 || !width || width <= 0 || !height || height <= 0 || !length || length <= 0 );
      }).map(item => item.serial);

      if (emptySKU) {
        this.pvSKUSerial = emptySKU.join();

        if(this.pvSKUSerial){
          this.empSKUError = `Error: Missing SKU (S.No. ${this.pvSKUSerial}) details. Fill L, B, H, and physical weight.`;
        }
      }
      return this.empSKUError;
    },

    verifyAWB() {
      if (!this.validateAWBInputs()) return false;

      this.pvSKUError = '';
      this.empSKUError = '';
      this.isLoadingSearch = true;

      this.input = ({
        parentAWB: this.AWBnumber,
        MpsCount: this.inputs.MPSCount,
        measurementmethod: "Manual",
        dimentionuom: "cm",
        measurementlocation: this.hubid,
        measurementdoneby: this.useremail,
        mpsstatus: "done",
        cft: this.CFTValue,
        ispvratiooutofrange: this.pvRatioFlag,
        pvminratio:this.pvMinRatio,
        pvmaxratio:this.pvMaxRatio,
        SKUDetails: this.inputs.SKUDetails.map(j => ({
          HSN: j.HSN,
          SKU: "Other",
          BoxType: "Other",
          SKUType: j.SKUType,
          NoOfBoxes: j.NoOfBoxes,
          UpdatedNoOfBoxes: j.NoOfBoxes,
          SKUAction: j.SKUAction,
          NoOfInscan: j.NoOfInscan,
          OtherBoxType: j.OtherBoxType,
          BoxDimensions: (j.PackageDetails.Dimensions.Length+'*'+j.PackageDetails.Dimensions.Width+'*'+j.PackageDetails.Dimensions.Height),
          PackageDetails: j.PackageDetails,
          ChildNoOfInscan: j.ChildNoOfInscan,
          UniqueReferenceNumber: j.UniqueReferenceNumber,
          ispvratiooutofrange: j.pvRatioFlag,
          wtinscan:j.wtinscan
        })),
        totalVerifiedPhysicalWeight:this.vpw!=''?this.vpw:this.ppw,
        totalVerifiedVolumetricWeight:this.vvw!=''?this.vvw:this.pvw
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'updateParentDetailsforAWBVerification',
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
      .then(result => {
        if (result.data.ReturnCode == 100) {
          //this.$alert(result.data.ReturnMessage, "", "success");
          this.$alertify.success(result.data.ReturnMessage);
          this.getAWBVerificationDimWt();
          this.isPhysicalWeightBeyondThreshold = []
          this.isVolumetricWeightBeyondThreshold = []
          
        } else if (result.data.ReturnCode == 102) {
          this.dwsModalShow = true;
          this.verificationMethod = 'dws';
          this.getAWBMPSDWSList();
        } else {
          this.$alert(result.data.ReturnMessage, "", "error");
        }
        this.isLoadingSearch = false;
      }, error => {
        this.isLoadingSearch = false;
        console.error(error)
      })
   },

    checkVerificationPalletizationEnabled() {

     this.isLoadingSearch = true;
     axios({
         method: 'GET',
         'url': apiUrl.api_url_hubops + 'checkVerificationPalletizationEnabled?hubId='+this.hubid+'&destinationhubId='+this.destinationhubId,
         headers: {
           'authorization': 'authkey xB84JJ89Hd25',
         }
       })
       .then(result => {
         this.isLoadingSearch = false;
         if (result.data.ResultCode == 100) {
           this.isverificationenabled = result.data.ResponseData[0].isverificationenabled;
           if(this.isverificationenabled == true){
            this.getAWBVerificationDimWt();
           }else{
            this.isverificationenabledMsg='For this Hub verification Hub is ' + result.data.verificationHubName + '.';
           }
         } else if (result.data.ResultCode == 107) {
           this.isverificationenabled = true;
           this.getAWBVerificationDimWt();
         } else {
           this.isverificationenabled = false;
           this.isverificationenabledMsg='The current Hub is not a controlling Hub for this AWB.';
         }
       }, error => {
         this.isverificationenabled = false; this.isLoadingSearch = false;
       })
    },

    verifyMPSDWS() {
      if (!this.validateAWBInputs()) return false;
        this.isLoadingSearch = true;
        this.input = ({
          parentAWB: this.AWBnumber,
          measurementmethod: "DWS",
          dimentionuom: "cm",
          measurementlocation: this.hubid,
          measurementdoneby: this.useremail,
          mpsstatus: "done",
          cft: this.CFTValue,
          ispvratiooutofrange: this.pvRatioFlag,
          pvminratio:this.pvMinRatio,
          pvmaxratio:this.pvMaxRatio,
          MPSDetails: this.inputs.MPSDetails.map(j => ({
            ShippingID: j.MPSno,
            PhyWeight: j.PhyWeight,
            VolWeight: j.VolWeight,
            BillableWeight: (Math.max(j.PhyWeight,j.VolWeight)).toString(),
            Height: j.Height,
            Length: j.Length,
            Unit: "cm",
            Width: j.Width,
            UniqueReferenceNumber: null
          })),
          totalVerifiedPhysicalWeight:this.vpw!=''?this.vpw:this.ppw,
          totalVerifiedVolumetricWeight:this.vvw!=''?this.vvw:this.pvw
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'updateParentDetailsforAWBVerification_DWS',
          'data': this.input,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ReturnCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            this.getAWBMPSDWSList();
            this.isPhysicalWeightBeyondThreshold = []
          this.isVolumetricWeightBeyondThreshold = []
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          this.isLoadingSearch = false;
        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })
     },

    async phywtDwsCalc(i)
    {
      this.isdisable = true;
      if(this.inputs.MPSDetails[i].PhyWeight<=0)
      {
        this.inputs.MPSDetails[i].PhyWeight = '';
        this.$alertify.error("Input value should be greater than 0!");
        return false;
      }
      if(this.inputs.MPSDetails[i].PhyWeight && this.inputs.MPSDetails[i].Length && this.inputs.MPSDetails[i].Width && this.inputs.MPSDetails[i].Height)
      {
        this.isdisable = false;
      }
      //  HUB:6668: Physical/Volumetric Wt validation on AWS Screen
        if(Number (this.inputs.MPSDetails[i].PhyWeight) >= this.inputs_config.max_mpsWt[0]){
         this.$alertify.error(`Physical weight should be less than ${this.inputs_config.max_mpsWt[0]}!`);
         this.isPhysicalWeightBeyondThreshold[i] = true;
         }else {
          this.isPhysicalWeightBeyondThreshold[i] = false;
         }
        
      await this.vvvpwtDwsCalc();
    },

    async volwtDwsCalc(i) {
      this.isdisable = true;
      if((this.inputs.MPSDetails[i].Length && this.inputs.MPSDetails[i].Length <= 0) ||
      (this.inputs.MPSDetails[i].Width && this.inputs.MPSDetails[i].Width <= 0) ||
      (this.inputs.MPSDetails[i].Height && this.inputs.MPSDetails[i].Height <= 0)){
        this.inputs.MPSDetails[i].Length = this.inputs.MPSDetails[i].Length > 0 ? this.inputs.MPSDetails[i].Length : '';
        this.inputs.MPSDetails[i].Width = this.inputs.MPSDetails[i].Width > 0 ? this.inputs.MPSDetails[i].Width : '';
        this.inputs.MPSDetails[i].Height = this.inputs.MPSDetails[i].Height > 0 ? this.inputs.MPSDetails[i].Height : '';

        this.$alertify.error("Input value should be greater than 0!"); return false;
      }

      if(this.inputs.MPSDetails[i].PhyWeight && this.inputs.MPSDetails[i].Length && this.inputs.MPSDetails[i].Width && this.inputs.MPSDetails[i].Height)
      {
        this.isdisable = false;
      }

      this.inputs.MPSDetails[i].VolWeight = ((Math.floor(parseFloat(((parseFloat(this.inputs.MPSDetails[i].Length) * parseFloat(this.inputs.MPSDetails[i].Width) * parseFloat(this.inputs.MPSDetails[i].Height)) / parseFloat(27000)) * parseFloat(this.CFTValue)) * 1000) / 1000).toFixed(3)).toString();
      await this.vvvpwtDwsCalc();
         //  //  HUB:6668: Physical/Volumetric Wt validation on AWS Screen
      if(Number (this.inputs.MPSDetails[i].VolWeight) >= this.inputs_config.max_mpsWt[1]){
        this.$alertify.error(`Volumetric weight should be less than ${this.inputs_config.max_mpsWt[1]}!`);
       this.isVolumetricWeightBeyondThreshold[i] = true;
      }else {
       this.isVolumetricWeightBeyondThreshold[i] = false;
      }
    },

    async vvvpwtDwsCalc() {
      this.vpw = (Math.floor(this.inputs.MPSDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.PhyWeight)); }, 0) * 1000) / 1000).toFixed(3);
      this.vvw = (Math.floor(this.inputs.MPSDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.VolWeight)); }, 0) * 1000) / 1000).toFixed(3);

      this.pwd = (Math.floor(parseFloat(parseFloat(this.vpw) - parseFloat(this.ppw)) * 1000) / 1000).toFixed(3);
      this.vwd = (Math.floor(parseFloat(parseFloat(this.vvw) - parseFloat(this.pvw)) * 1000) / 1000).toFixed(3);
      
      this.calcPVRatio();

      //  HUB:6668: Physicaly/Volumetric AWS Wt validation on AWS Screen
      if(Number (this.vvw) >= this.inputs_config.max_parentWt[1]){
        this.$alertify.error(`Volumetric AWB weight should be less than ${this.inputs_config.max_parentWt[1]}!`);
        return false;
        } else if (Number (this.vpw) >= this.inputs_config.max_parentWt[0]){
         this.$alertify.error(`Physical weight AWB weight should be less than ${this.inputs_config.max_parentWt[0]}!`);
         }
       

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/AWBVerificationDimWt_v1/AWBVerificationDimWt_v1.component.js